"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Note: this content will likely be static,
// but we might consider changing it depending
// on the phase of the process


var FAQ = function FAQ() {
  return (
    /*#__PURE__*/
    _react.default.createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      bold: true,
      type: "base"
    }, "What is 10DLC?"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    }, "Carriers are introducing a\u202Fnew set of standards\u202Fand registration processes\u202Ffor\u202F10DLC numbers (\u201C10-digit\u202Flong code\u201D -\u202Fthe fancy term for\u202Fyour\u202Flocal\u202Flandline or VoIP\u202Fnumber)\u202Fdesigned\u202Fto support higher message speed,\u202Fimprove deliverability and\u202Fincrease sending trust across\u202Fthe 10DLC texting\u202Fchannel.\u202F\u202F"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      bold: true,
      type: "base"
    }, "What action do I need to take?"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    }, "Registering is simple. Click on the \u201CRegister Now\u201D button to the left of this page, enter your business information in the required fields*, and click Submit when all information is filled in. That\u2019s all you need to do! We\u2019ll take care of the rest, including annual registration renewal."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      bold: true,
      type: "base"
    }, "What happens if I don\u2019t submit my business information?"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    }, "If you register by March 1, you will not experience any\u202Fimpact\u202Fto\u202Fyour service.\u202FFailing to register by this date could result in future disruption to service by some carriers. You may also be subject to certain 10DLC fees."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      bold: true,
      type: "base"
    }, "Where can I learn more?"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      type: "base"
    },
    /*#__PURE__*/
    _react.default.createElement("span", null, "We\u2019re here to help you navigate the process to ensure there is no impact\u202Fto\u202Fyour service.\u202FIf you have questions, please\u202Freference\u202Fthe\u202FFAQ\u202F",
    /*#__PURE__*/
    _react.default.createElement("a", {
      href: "https://www.zipwhip.com/10dlc-frequently-asked-questions/",
      target: "_blank",
      rel: "noreferrer noopener"
    }, "here"), ".\u202F\u202F\u202F")))
  );
};

var _default = FAQ;
exports.default = _default;